import type { Contact } from "../../core/types";
import { detectLocale } from "../../utils/localeUtil";
import storageService from "./storageService";
import { getErrorStatus } from "../utils/getErrorStatus";

export type LoginCodeResult =
  | { success: true; contact: Contact }
  | { success: false; status: number | undefined };

export const createLoginCode = async (
  apiUrl: string,
  token: string,
  widgetId: string,
  email: string,
  signal: AbortSignal,
): Promise<LoginCodeResult> => {
  const url = new URL(`${apiUrl}/login_codes`);
  url.searchParams.set("lang", detectLocale() ?? "");

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        uuid: storageService.getContact(widgetId, "uuid"),
        widget_id: widgetId,
      }),
      signal,
    });

    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`, {
        cause: response.status,
      });
    }

    const contact = (await response.json()) as Contact;
    return { success: true, contact };
  } catch (error) {
    return { success: false, status: getErrorStatus(error) };
  }
};

export const verifyLoginCode = async (
  apiUrl: string,
  token: string,
  widgetId: string,
  email: string,
  code: string,
  signal: AbortSignal,
): Promise<LoginCodeResult> => {
  const url = new URL(`${apiUrl}/login_codes/verify`);
  url.searchParams.set("code", code);
  url.searchParams.set(
    "uuid",
    storageService.getContact(widgetId, "uuid") as string,
  );
  url.searchParams.set("email", email);
  url.searchParams.set("widget_id", widgetId);

  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      signal,
    });

    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`, {
        cause: response.status,
      });
    }

    const contact = (await response.json()) as Contact;
    return { success: true, contact };
  } catch (error) {
    return { success: false, status: getErrorStatus(error) };
  }
};

